export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			exchangeRate: [
				{name: "Average Rate", value: "Average Rate"},
				{name: "Closing Rate", value: "Closing Rate"}
			]
		}
	},
};